var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcCardBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 140,
    viewBox: "0 0 408 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 24,
    height: 72,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20,
    width: 24,
    height: 100,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    width: 24,
    height: 140,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 20,
    width: 24,
    height: 100,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 34,
    width: 24,
    height: 72,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 50,
    width: 24,
    height: 40,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 34,
    width: 24,
    height: 72,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 20,
    width: 24,
    height: 100,
    rx: 12,
    fill: "#13AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    width: 24,
    height: 140,
    rx: 12,
    fill: "#13AE67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcCardBg1);
export default __webpack_public_path__ + "static/media/stick-ic-card-bg1.177f4e648463544e3fe5550b66bfd21f.svg";
export { ForwardRef as ReactComponent };